import { FC, Children, Fragment } from 'react';
import { Box, BoxProps } from '@mui/material';

/**
 * @summary Контейнер для группирования кнопок в таблице. Нужен для того,
 * чтобы можно было в любой момент переопределить логику отображения
 * групп кнопок в таблице.
 *
 * @description Обёрнутые в этот компонент кнопки равномерно распределяются
 * по родителю с правилом space-evenly.
 */
const MUIButtonGroup: FC<Partial<BoxProps>> = (props) => {
  const { children, ...otherProps } = props;
  return (
    <Box display="flex" justifyContent="space-evenly" {...otherProps}>
      {Children.map(children, (button, index) => (
        <Fragment key={index}>{button}</Fragment>
      ))}
    </Box>
  );
};

export default MUIButtonGroup;
